import axios from 'axios';
import config from '../config/config';

const apiUrl = config.apiBaseUrl;

// usuarioId desde sessionStorage
export const getUsuarioId = () => {
  try {
    const raw = sessionStorage.getItem('UsuarioId');
    if (!raw) return 0;
    if (typeof raw === 'string' && raw.startsWith('{')) {
      const parsed = JSON.parse(raw);
      return Number(parsed?.USUARIOID || parsed?.id || 0);
    }
    return Number(raw);
  } catch {
    return Number(sessionStorage.getItem('UsuarioId') || 0);
  }
};

// empresaId “actual” (si eligió TODAS, lo dejamos en 0 para global)
export const getEmpresaIdForPrefs = () => {
  const nombre = sessionStorage.getItem('EmpresaNombre'); // "TODAS" o nombre real
  if (nombre === 'TODAS') return 0;

  try {
    const raw = sessionStorage.getItem('EmpresaId');
    if (!raw) return 0;

    // Si viene como array JSON "[1]" o "[1,3]"
    if (typeof raw === 'string' && raw.trim().startsWith('[')) {
      const ids = JSON.parse(raw);
      const first = Array.isArray(ids) ? ids[0] : null;
      return first ? Number(first) : 0;
    }

    // Si viene como número o string "1"
    const num = Number(raw);
    return Number.isFinite(num) && num > 0 ? num : 0;
  } catch {
    return 0;
  }
};

export async function fetchUserPrefs({ modulo, vista = 'main' }) {
  const usuarioId = getUsuarioId();
  const empresaId = getEmpresaIdForPrefs();

  if (!usuarioId || !modulo) return null;

  const { data } = await axios.get(`${apiUrl}/api/userPrefs`, {
    params: { usuarioId, empresaId, modulo, vista },
  });

  return data?.pref ? data.pref : null;
}

export async function saveUserPrefs({ modulo, vista = 'main', pref }) {
  const usuarioId = getUsuarioId();
  const empresaId = getEmpresaIdForPrefs();

  if (!usuarioId || !modulo) return;

  await axios.post(`${apiUrl}/api/userPrefs`, {
    usuarioId,
    empresaId,
    modulo,
    vista,
    pref,
  });
}